
export default function MetodoBCISection() {
  const fasi = [
    {
      numero: '01',
      titolo: 'Analisi Preliminare',
      descrizione: 'Valutazione iniziale del patrimonio aziendale e identificazione delle opportunità di valorizzazione',
      icon: 'ri-search-eye-line',
    },
    {
      numero: '02',
      titolo: 'Valutazione Certificata',
      descrizione: 'Perizia professionale conforme agli standard ISO 10668 per la stima del brand value',
      icon: 'ri-shield-check-line',
    },
    {
      numero: '03',
      titolo: 'Strategia di Valorizzazione',
      descrizione: 'Definizione del piano strategico per massimizzare il valore degli asset intangibili',
      icon: 'ri-lightbulb-line',
    },
    {
      numero: '04',
      titolo: 'Implementazione',
      descrizione: 'Supporto operativo nella realizzazione delle strategie di valorizzazione e protezione',
      icon: 'ri-rocket-line',
    },
  ];

  return (
    <section id="metodo" className="py-16 sm:py-20 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16 lg:mb-20">
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0B1F3B] mb-4 sm:mb-6">
            Il Metodo BCI
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-[#1C1C1C]/70 max-w-3xl mx-auto leading-relaxed px-4">
            Un approccio strutturato e certificato per valorizzare il patrimonio della tua azienda
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 lg:gap-10">
          {fasi.map((fase, index) => (
            <div
              key={index}
              className="relative bg-gradient-to-br from-[#F8F9FA] to-white p-6 sm:p-8 lg:p-10 rounded-xl border-2 border-[#E879F9]/20 hover:border-[#E879F9]/40 transition-all duration-300 hover:shadow-xl group"
            >
              <div className="flex items-start gap-4 sm:gap-6 mb-4 sm:mb-6">
                <div className="flex-shrink-0 w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-[#22C55E]/10 rounded-lg group-hover:bg-[#22C55E]/20 transition-colors">
                  <i className={`${fase.icon} text-3xl sm:text-4xl text-[#22C55E]`}></i>
                </div>
                <div className="flex-1">
                  <div className="text-5xl sm:text-6xl lg:text-7xl font-bold text-[#E879F9]/10 absolute top-4 right-4 sm:top-6 sm:right-6 font-serif">
                    {fase.numero}
                  </div>
                  <h3 className="text-xl sm:text-2xl font-bold text-[#0B1F3B] mb-3 sm:mb-4 relative z-10">
                    {fase.titolo}
                  </h3>
                </div>
              </div>
              <p className="text-sm sm:text-base text-[#1C1C1C]/70 leading-relaxed">
                {fase.descrizione}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 sm:mt-16 lg:mt-20 text-center">
          <a
            href="#contatti"
            className="inline-block px-8 sm:px-10 py-3 sm:py-4 bg-[#E879F9] text-white rounded-md text-base sm:text-lg font-semibold hover:bg-[#E879F9]/90 transition-all whitespace-nowrap cursor-pointer"
          >
            Inizia la Tua Valutazione
          </a>
        </div>
      </div>
    </section>
  );
}
